/*
 * Armador del menu semanal de Jackie Guiloff.
 *
 * POR QUE LA SELECCION ES LOCAL Y NO VA AL CARRITO DE INMEDIATO
 * Hay un minimo de platos que respetar. Si cada plato entrara al carrito al tocarlo,
 * el minimo no se podria sostener: el cliente puede ir al checkout desde el icono del
 * carrito y saltarse esta pagina. Armando la seleccion aca y mandandola completa
 * cuando alcanza el minimo, el carrito nunca recibe una seleccion invalida.
 *
 * HUECO CONOCIDO: alguien puede agregar 3 y despues borrar 2 desde el carrito.
 * Cerrarlo requiere validar en el carrito o una funcion de validacion de checkout.
 *
 * TRAMPA QUE YA COSTO UN BUG (08 ago): el cajon del carrito de Prestige escucha
 * cart:change y hace event.detail.cart["sections"][sectionId] SIN GUARDAS. Si se
 * despacha ese evento sin el campo sections, tira TypeError y el cajon nunca se abre,
 * aunque el carrito si se haya actualizado. Por eso aca se piden las secciones al tema
 * con cart:prepare-bundled-sections y se mandan en el body; y si aun asi no vinieran,
 * NO se despacha cart:change, solo cart:refresh, para no romper el tema.
 */
(function () {
  if (window.customElements.get('jgg-menu-semanal')) return;

  class JggMenuSemanal extends HTMLElement {
    connectedCallback() {
      this.moneda = this.getAttribute('moneda') || 'CLP';
      this.minimo = parseInt(this.getAttribute('minimo') || '0', 10);
      if (isNaN(this.minimo)) this.minimo = 0;
      this.textoSinPrecio = this.getAttribute('texto-sin-precio') || 'Precio por confirmar';
      this.textoAgregado = this.getAttribute('texto-agregado') || 'Listo, tu menu esta en el carrito';
      this.textoError = this.getAttribute('texto-error') || 'No pudimos guardar tu menu. Intenta de nuevo.';
      this.textoFaltaUno = this.getAttribute('texto-falta-uno') || 'Elige 1 plato mas para continuar';
      this.textoFaltaVarios = this.getAttribute('texto-falta-varios') || 'Elige {n} platos mas para continuar';

      this.items = Array.from(this.querySelectorAll('.jgg-ms__item'));
      this.vacio = this.querySelector('[data-vacio]');
      this.aviso = this.querySelector('[data-aviso]');
      this.botonEnviar = this.querySelector('[data-enviar]');
      this.estado = this.prepararEstado();

      this.seleccion = {};
      this.enCarrito = {};

      this.abortController = new AbortController();
      this.addEventListener('click', this.alHacerClic.bind(this), { signal: this.abortController.signal });

      this.aplicarFormato(this.getAttribute('formato-inicial') || '1');
      this.filtrar('todos');
      this.sembrarDesdeCarrito();

      console.info('[jgg-menu-semanal] listo:', this.items.length, 'platos, minimo', this.minimo);
    }

    disconnectedCallback() {
      if (this.abortController) this.abortController.abort();
    }

    prepararEstado() {
      let el = this.querySelector('[data-estado]');
      if (el) return el;
      const barra = this.querySelector('.jgg-ms__barra');
      if (!barra) return null;
      el = document.createElement('p');
      el.setAttribute('data-estado', '');
      el.hidden = true;
      el.style.cssText = 'flex-basis:100%;margin:0;font-size:0.85rem;';
      barra.appendChild(el);
      return el;
    }

    /* ---------- utilidades ---------- */

    todosLosIds() {
      const ids = [];
      this.items.forEach(function (item) {
        Object.keys(item.dataset).forEach(function (k) {
          if (k.charAt(0) === 'v' && item.dataset[k]) ids.push(item.dataset[k]);
        });
      });
      return ids;
    }

    precioDe(id) {
      for (let i = 0; i < this.items.length; i += 1) {
        const ds = this.items[i].dataset;
        const claves = Object.keys(ds);
        for (let j = 0; j < claves.length; j += 1) {
          const k = claves[j];
          if (k.charAt(0) === 'v' && ds[k] === id) {
            return parseInt(ds['p' + k.slice(1)] || '0', 10);
          }
        }
      }
      return 0;
    }

    formatear(centavos) {
      try {
        return new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: this.moneda,
          maximumFractionDigits: 0
        }).format(centavos / 100);
      } catch (error) {
        return '$' + Math.round(centavos / 100).toLocaleString('es-CL');
      }
    }

    anunciar(mensaje, esError) {
      if (this.aviso) this.aviso.textContent = mensaje;
      if (this.estado) {
        this.estado.textContent = mensaje;
        this.estado.hidden = !mensaje;
        this.estado.style.opacity = esError ? '1' : '0.85';
        this.estado.style.fontWeight = esError ? '600' : '400';
      }
    }

    /* ---------- estado ---------- */

    async sembrarDesdeCarrito() {
      try {
        const respuesta = await fetch(window.Shopify.routes.root + 'cart.js');
        const carro = await respuesta.json();
        const mios = this.todosLosIds();
        const self = this;
        carro.items.forEach(function (linea) {
          const id = String(linea.variant_id);
          if (mios.indexOf(id) !== -1) {
            self.seleccion[id] = linea.quantity;
            self.enCarrito[id] = linea.quantity;
          }
        });
      } catch (error) {
        console.error('[jgg-menu-semanal] no se pudo leer el carrito:', error);
      }
      this.pintar();
    }

    totalPlatos() {
      const s = this.seleccion;
      return Object.keys(s).reduce(function (suma, id) { return suma + s[id]; }, 0);
    }

    totalPrecio() {
      const self = this;
      return Object.keys(this.seleccion).reduce(function (suma, id) {
        return suma + self.precioDe(id) * self.seleccion[id];
      }, 0);
    }

    pintar() {
      const f = this.formato;
      const seleccion = this.seleccion;

      this.items.forEach(function (item) {
        const id = item.dataset['v' + f] || '';
        const cantidad = id ? seleccion[id] || 0 : 0;
        const paso = item.querySelector('[data-paso]');
        const elegir = item.querySelector('[data-elegir]');
        const elCantidad = item.querySelector('[data-cantidad]');
        const disponible = !item.classList.contains('is-nd');

        if (elCantidad) elCantidad.textContent = cantidad;
        item.classList.toggle('is-elegido', cantidad > 0);

        if (paso) paso.hidden = cantidad === 0 || !disponible;
        if (elegir) elegir.hidden = cantidad > 0 && disponible;
      });

      const total = this.totalPlatos();
      const faltan = Math.max(0, this.minimo - total);
      const elConteo = this.querySelector('[data-conteo]');
      const elTotal = this.querySelector('[data-total]');
      const envoltura = this.querySelector('[data-total-envoltura]');
      const elFalta = this.querySelector('[data-falta]');

      if (elConteo) elConteo.textContent = total;
      if (elTotal) elTotal.textContent = this.formatear(this.totalPrecio());
      if (envoltura) envoltura.hidden = total === 0;

      if (elFalta) {
        if (faltan === 0) {
          elFalta.textContent = '';
        } else if (faltan === 1) {
          elFalta.textContent = this.textoFaltaUno;
        } else {
          elFalta.textContent = this.textoFaltaVarios.replace('{n}', faltan);
        }
      }

      if (this.botonEnviar) this.botonEnviar.disabled = total < this.minimo || total === 0;
    }

    /* ---------- interaccion ---------- */

    alHacerClic(evento) {
      const chipFormato = evento.target.closest('[data-formato]');
      if (chipFormato) {
        this.aplicarFormato(chipFormato.dataset.formato);
        this.marcarActivo('[data-formato]', chipFormato);
        this.pintar();
        return;
      }

      const chipSub = evento.target.closest('[data-sub]');
      if (chipSub) {
        this.filtrar(chipSub.dataset.sub);
        this.marcarActivo('[data-sub]', chipSub);
        return;
      }

      if (evento.target.closest('[data-enviar]')) {
        evento.preventDefault();
        this.enviar();
        return;
      }

      const item = evento.target.closest('.jgg-ms__item');
      if (!item) return;

      if (evento.target.closest('[data-elegir]') || evento.target.closest('[data-mas]')) {
        this.cambiar(item, 1);
        return;
      }
      if (evento.target.closest('[data-menos]')) {
        this.cambiar(item, -1);
      }
    }

    cambiar(item, delta) {
      const id = item.dataset['v' + this.formato] || '';
      if (!id) {
        console.warn('[jgg-menu-semanal] la tarjeta no tiene variante para el formato', this.formato, item.dataset);
        return;
      }
      const actual = this.seleccion[id] || 0;
      const nuevo = Math.max(0, actual + delta);
      if (nuevo === 0) {
        delete this.seleccion[id];
      } else {
        this.seleccion[id] = nuevo;
      }
      this.anunciar('', false);
      this.pintar();
    }

    marcarActivo(selector, activo) {
      this.querySelectorAll(selector).forEach(function (el) {
        const esActivo = el === activo;
        el.classList.toggle('is-active', esActivo);
        el.setAttribute('aria-pressed', esActivo ? 'true' : 'false');
      });
    }

    aplicarFormato(formato) {
      this.formato = String(formato);
      const f = this.formato;
      const sinPrecio = this.textoSinPrecio;
      this.items.forEach(function (item) {
        const id = item.dataset['v' + f] || '';
        const precio = parseInt(item.dataset['p' + f] || '0', 10);
        const etiquetaPrecio = item.dataset['m' + f] || '';
        const disponible = id !== '' && precio > 0;
        const elPrecio = item.querySelector('[data-precio]');
        const elegir = item.querySelector('[data-elegir]');
        item.classList.toggle('is-nd', !disponible);
        if (elPrecio) elPrecio.textContent = disponible ? etiquetaPrecio : sinPrecio;
        if (elegir) elegir.disabled = !disponible;
      });
    }

    filtrar(sub) {
      let visibles = 0;
      this.items.forEach(function (item) {
        const subs = (item.dataset.subs || '').split(' ');
        const mostrar = sub === 'todos' || subs.indexOf(sub) !== -1;
        item.hidden = !mostrar;
        if (mostrar) visibles += 1;
      });
      if (this.vacio) this.vacio.hidden = visibles > 0;
    }

    /* ---------- enviar al carrito ---------- */

    async enviar() {
      const total = this.totalPlatos();
      if (total < this.minimo || total === 0) return;

      const updates = {};
      const seleccion = this.seleccion;
      Object.keys(seleccion).forEach(function (id) { updates[id] = seleccion[id]; });
      Object.keys(this.enCarrito).forEach(function (id) {
        if (!(id in updates)) updates[id] = 0;
      });

      // Le preguntamos al tema que secciones quiere que se le devuelvan re-renderizadas.
      // Es el mismo paso que hace el ProductForm nativo de Prestige antes de cart/add.js.
      const secciones = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: secciones }
      }));

      const cuerpoPeticion = { updates: updates };
      if (secciones.length > 0) {
        cuerpoPeticion.sections = secciones.join(',');
        cuerpoPeticion.sections_url = window.location.pathname;
      }

      console.info('[jgg-menu-semanal] enviando al carrito:', updates, 'secciones:', secciones);
      this.botonEnviar.setAttribute('aria-busy', 'true');
      this.anunciar('', false);

      try {
        const respuesta = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(cuerpoPeticion)
        });

        const cuerpo = await respuesta.json();

        if (!respuesta.ok) {
          console.error('[jgg-menu-semanal] cart/update.js respondio', respuesta.status, cuerpo);
          throw new Error(cuerpo.description || cuerpo.message || ('Error ' + respuesta.status));
        }

        const self = this;
        this.enCarrito = {};
        Object.keys(this.seleccion).forEach(function (id) { self.enCarrito[id] = self.seleccion[id]; });

        this.anunciar(this.textoAgregado, false);
        this.pintar();

        // cart:refresh siempre: actualiza contador del header y contenido del cajon.
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // cart:change SOLO si tenemos las secciones. Sin ellas, el handler del cajon
        // de Prestige revienta con TypeError antes de abrirlo.
        if (cuerpo.sections && typeof cuerpo.sections === 'object') {
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
            bubbles: true,
            detail: { baseEvent: 'variant:add', cart: cuerpo }
          }));
        } else {
          console.warn('[jgg-menu-semanal] la respuesta no trajo secciones; no se abre el cajon.');
        }
      } catch (error) {
        console.error('[jgg-menu-semanal] fallo al guardar el menu:', error);
        this.anunciar(error.message || this.textoError, true);
      } finally {
        this.botonEnviar.removeAttribute('aria-busy');
      }
    }
  }

  window.customElements.define('jgg-menu-semanal', JggMenuSemanal);
})();
